import { useTranslation } from 'react-i18next';

export default function Impressum({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="min-h-[100dvh] bg-[var(--aif-bg-page)] text-[var(--aif-text-primary)]">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          {onBack && (
            <button
              onClick={onBack}
              className="p-2 rounded-lg hover:bg-[var(--aif-bg-surface)] transition"
              aria-label={t('onboarding.back')}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          <h1 className="text-2xl font-bold">Impressum</h1>
        </div>

        <div className="prose dark:prose-invert max-w-none space-y-6">
          {/* Betreiber */}
          <section>
            <h2 className="text-xl font-semibold mb-3">Angaben gem&auml;&szlig; &sect; 5 TMG</h2>

            <h3 className="text-lg font-medium mt-4 mb-2">Betreiber und Diensteanbieter</h3>
            <p>
              <strong>ALCEDO Management GmbH</strong><br />
              Musterstra&szlig;e 1<br />
              20095 Hamburg<br />
              Deutschland
            </p>
            <p>
              <strong>Gesch&auml;ftsf&uuml;hrer:</strong> Hubertus Mai<br />
              <strong>E-Mail:</strong>{' '}
              <a href="mailto:info@alcedo-management.com" className="text-[var(--aif-color-primary)] hover:underline">
                info@alcedo-management.com
              </a><br />
              <strong>Telefon:</strong> +49 40 123456
            </p>
            <p>
              <strong>Registergericht:</strong> Amtsgericht Hamburg<br />
              <strong>Registernummer:</strong> HRB 12345<br />
              <strong>Umsatzsteuer-Identifikationsnummer gem. &sect; 27a UStG:</strong> DE123456789
            </p>
          </section>

          {/* Lizenznehmer */}
          <section>
            <h3 className="text-lg font-medium mt-4 mb-2">Lizenznehmer und Vertriebspartner</h3>
            <p>
              <strong>Airfarm GmbH</strong><br />
              Agrarstra&szlig;e 10<br />
              10115 Berlin<br />
              Deutschland
            </p>
            <p>
              Vertrieb und Lizenzierung f&uuml;r den DACH-Raum
              (Deutschland, &Ouml;sterreich, Schweiz).
            </p>
          </section>

          {/* Verantwortlich f&uuml;r den Inhalt */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              Verantwortlich f&uuml;r den Inhalt gem. &sect; 18 Abs. 2 MStV
            </h2>
            <p>
              Hubertus Mai<br />
              ALCEDO Management GmbH<br />
              Musterstra&szlig;e 1<br />
              20095 Hamburg
            </p>
          </section>

          {/* Streitschlichtung */}
          <section>
            <h2 className="text-xl font-semibold mb-3">Streitschlichtung</h2>
            <p>
              Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
              bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[var(--aif-color-primary)] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          {/* Haftung f&uuml;r Inhalte */}
          <section>
            <h2 className="text-xl font-semibold mb-3">Haftung f&uuml;r Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs. 1 TMG f&uuml;r eigene Inhalte auf
              diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG
              sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder
              gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen,
              die auf eine rechtswidrige T&auml;tigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist
              jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
              umgehend entfernen.
            </p>
          </section>

          {/* Haftung f&uuml;r Links */}
          <section>
            <h2 className="text-xl font-semibold mb-3">Haftung f&uuml;r Links</h2>
            <p>
              Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir
              keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine
              Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige
              Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p>
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche
              Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
              Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="text-xl font-semibold mb-3">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung,
              Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes
              bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          <p className="text-sm text-[var(--aif-text-muted)] mt-8">
            Stand: M&auml;rz 2026
          </p>
        </div>
      </div>
    </div>
  );
}
